import * as z from "zod";

export const ProductivityDashboardItemSchema = z.object({
  teamMemberName: z.string(),
  teamMemberEmail: z.string(),
  ordersFulfilled: z.number(),
  productsFulfilled: z.number(),
  ouncesFulfilled: z.number(),
  dollarsSpent: z.number(),
  averageDollarsPerOunce: z.number(),
  ordersVerified: z.number(),
  ordersVerifiedRate: z.number(),
  itemsPicked: z.number().nullish(),
  ordersPicked: z.number().nullish(),
  avgSecondsPerItem: z.number().nullish(),
  problemOrdersCompleted: z.number().nullish(),
  problemOrdersMarked: z.number().nullish(),
  problemRate: z.number().nullish(),
  itemsPickedPerHour: z.number().nullish(),
  ordersPickedPerHour: z.number().nullish(),
  singleItemPicksPerHour: z.number().nullish(),
  multiItemPicksPerHour: z.number().nullish(),
});

export type ProductivityDashboardItem = z.infer<
  typeof ProductivityDashboardItemSchema
>;
